import { makeContextModule } from '@cian/react-utils';

import type { IApplicationContext } from 'shared/containers/App';

export const {
  Context: ApplicationContext,
  useContext: useApplicationContext,
  withContext: withApplicationContext,
} = makeContextModule<IApplicationContext>({
  contextName: 'ApplicationContext',
});
